import { call, put, select, takeLatest } from 'redux-saga/effects'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { IAdditionalAssessmentsState } from '../store/additionalAssessments.types'
import { AdditionalAssessmentsConstants } from '../store/additionalAssessments.constants'
import { resetSelectedAssessment, setAssessmentsList, setAssessmentSeq } from '../store/additionalAssessments.actions'
import { getAdditionalAssessmentsSelector } from '../selectors'
import { IBodySurveyState } from '../bodyAssessment/bodySurvey/store/bodySurvey.types'
import { resetDrainsAndTubes } from '../bodyAssessment/drainsTubes/store/drainsAndTubes.actions'
import { resetBurns } from '../bodyAssessment/burns/store/burns.actions'
import { resetObstetrics } from '../bodyAssessment/obstetrics/store/obstetrics.actions'
import { setAssessmentSeq as setBodyAssessmentSeq } from '../bodyAssessment/bodySurvey/store/bodySurvey.actions'
import { getRulesSelector } from '../../rules/selectors'
import { IRulesState } from '../../rules/store/rules.types'
import { clearValidationErrorsByPathList } from '../../../utilities/runRulesValidation.util'

export function* deleteAssessment() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const additionalAssessment: IAdditionalAssessmentsState = yield select(getAdditionalAssessmentsSelector)
  const { deleteAssessment, bodySurveys } = additionalAssessment
  const rules: IRulesState = yield select(getRulesSelector)
  if (pcrID) {
    try {
      const cloneAssessments = [...bodySurveys]
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (cloneAssessments?.length > 0) {
        const updatedAssessmentList = cloneAssessments.filter(
          (assessment: IBodySurveyState) => assessment.seq !== deleteAssessment
        )
        let pcrDocUpdated: any = { ...pcrDoc }
        if (updatedAssessmentList.length === 0) {
          delete pcrDocUpdated.additionalAssessment
          yield put(resetDrainsAndTubes())
          yield put(resetBurns())
          yield put(resetObstetrics())
          yield put(setAssessmentsList([]))
          rules.errors = clearValidationErrorsByPathList(rules.errors, [
            AdditionalAssessmentsConstants.OBSTETRICS,
            AdditionalAssessmentsConstants.DRAINS_AND_TUBES,
          ])
        } else {
          pcrDocUpdated = {
            ...pcrDoc,
            additionalAssessment: {
              ...pcrDoc.additionalAssessment,
              bodySurveys: updatedAssessmentList,
            },
          }
          yield put(resetSelectedAssessment())
          yield put(setAssessmentsList(updatedAssessmentList))
          const lastAssessment = updatedAssessmentList[updatedAssessmentList.length - 1]
          const sequence = lastAssessment.seq
          yield put(setAssessmentSeq(sequence))
          yield put(setBodyAssessmentSeq(sequence))
        }
        yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      }
    } catch (e) {
      yield put(throwPcrException(`deleteAssessment() error: ${e}`))
    }
  }
}

export function* deleteAssessmentSaga() {
  yield takeLatest([AdditionalAssessmentsConstants.DELETE_ASSESSMENT], performWithMutexHOG, deleteAssessment)
}
